<template>
  <div>
      <main-header></main-header>
      <div class="pagebanner1" :style="{background:'url('+ banner.img +') center 0 no-repeat'}">
        <div>{{banner.title}}</div>
      </div>
      <div class="page">
        <div class="w1200">
          <div class="subnav">
            <a href="javascript:;" v-for="(type,index) in types" :key="index" :class="{s:type.id==id}" @click="getlist(type.id,index)">
              {{type.title}}
            </a>
          </div>
          <ul class="newslist">
            <li v-for="(item,index) in newsdata" :key="index">
              <router-link v-bind:to="{name:'newspage',params:{id:item.id}}">
                <div class="picbox">
                  <img :src="item.image == null ? defaultpicture : item.image" alt="">
                </div>
                <div class="cont">
                  <h1>{{item.title}}</h1>
                  <span class="sp2">{{item.describe}}</span>
                  <span class="sp3">{{item.update_time}}</span>
                </div>
              </router-link>
            </li>
          </ul>
          <div class="newslist-pageindex">
            <a href="javascript:;" @click="page(1)">{{language[languagetype].first}}</a>
            <a href="javascript:;" @click="page(cur-1)">{{language[languagetype].prev}}</a>
            <a href="javascript:;" v-if="cur >= 2 && all!=2">...</a>
            <a href="javascript:;" v-for="index in pageindexarr" :key="index" @click="page(index)" :class="{active:cur===index}">{{index}}</a>
            <a href="javascript:;" v-if="all > 2">...</a>
            <a href="javascript:;" @click="page(cur+1)">{{language[languagetype].next}}</a>
            <span>{{language[languagetype].gonga}}{{alllength}}{{language[languagetype].tiao}} {{language[languagetype].gongb}}{{all}}{{language[languagetype].ye}}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import MainHeader from './header'
import Fetch from '../js/ajaxa'
let languagetext = require('../js/newspage.json')
export default {
  name: 'about',
  data () {
    return {
      id: '',
      banner: {
        img: '',
        title: ''
      },
      types: [],
      i: 0,
      defaultpicture: '',
      newsdata: [],
      all: 1,
      cur: 1,
      pageindexarr: [],
      lang: 1,
      language: {},
      languagetype: 'cn',
      alllength: 1
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.id !== from.params.id && to.name === 'newslist' && from.name === 'newslist') {
        const that = this
        that.id = this.$route.params.id
        Fetch.post('Api/news?page=1', {
          classify_id: that.id
        }).then((res) => {
          that.newsdata = res.data
          that.all = res.last_page
          that.cur = 1
          if (that.all >= 2) {
            that.pageindexarr = [1, 2]
          } else {
            that.pageindexarr = [1]
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    if (to.name === 'newspage') {
      // 前往详情页面时缓存页面
      from.meta.keepAlive = true
    } else {
      // 是去 C 页面，缓存
      from.meta.keepAlive = false
    }
    next()
  },
  methods: {
    getlist: function (newsid, index) {
      this.i = index
      this.id = newsid
      this.$router.push({
        params: {
          id: newsid
        }
      })
      const that = this
      Fetch.post('Api/news?page' + index, {
        classify_id: that.id
      }).then((res) => {
        that.newsdata = res.data
        that.all = res.last_page
        that.alllength = res.total
        that.cur = 1
        if (that.all >= 2) {
          that.pageindexarr = [1, 2]
        } else {
          that.pageindexarr = [1]
        }
      })
    },
    page (index) {
      const that = this
      if (index <= 0) {
        index = 1
      }
      if (index >= this.all) {
        index = this.all
      }
      if (index + 1 <= this.all) {
        this.pageindexarr = [index, index + 1]
      } else {
        if (index === 1) {
          this.pageindexarr = [1]
        } else {
          this.pageindexarr = [index - 1, index]
        }
      }
      this.cur = index
      Fetch.post('Api/news?page=' + index, {
        classify_id: that.$route.params.id
      }).then((res) => {
        that.newsdata = res.data
        that.all = res.last_page
        that.alllength = res.total
        if (that.all >= 2) {
          that.pageindexarr = [1, 2]
        } else {
          that.pageindexarr = [1]
        }
      })
    }
  },
  components: {
    MainHeader
  },
  created () {
    const that = this
    that.id = this.$route.params.id
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    Fetch.post('Api/newsConfig', {
    }).then((res) => {
      that.defaultpicture = res.image
      that.banner.img = res.banner
      that.banner.title = res.sub_title
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/classify', {
    }).then((res) => {
      that.types = res
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/news?page=1', {
      classify_id: that.id
    }).then((res) => {
      that.newsdata = res.data
      that.all = res.last_page
      that.alllength = res.total
      if (that.all >= 2) {
        that.pageindexarr = [1, 2]
      } else {
        that.pageindexarr = [1]
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pagebanner1{height: 400px;overflow: hidden;display: flex;align-items: center;justify-content: center;font-size: 40px;color: #fff;}
  .page{min-height: 600px;}
  .page .w1200{overflow: visible;}
  .subnav{width: 100%;height: 40px;overflow: hidden;text-align: center;margin-top: 48px;}
  .subnav a{display: inline-block;width: 110px;height: 40px;box-sizing: border-box;border:1px solid #c5c5c5;color: #c5c5c5;text-align: center;line-height: 38px;font-size: 16px;margin-left: 12px;margin-right: 12px;}
  .subnav .s{background-color: #2562ef;color: #fff;border:1px solid #2562ef;}
  .subnav a:hover{background-color: #2562ef;color: #fff;border:1px solid #2562ef;}
  .newslist{width: 100%;height: auto;overflow: visible;margin-top: 20px;}
  .newslist li{width: 100%;height: 162px;margin-bottom: 20px;box-sizing: border-box;border:1px solid #f6f6f6}
  .newslist li a{display: block;width: 100%;height: 100%;overflow: hidden;}
  .newslist li .picbox{width: 290px;height: 160px;float: left;overflow: hidden;}
  .newslist li .picbox img{width: 290px;height: 160px;object-fit:cover;transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;}
  .newslist li:hover .picbox img{transform: scale(1.2);}
  .newslist li:hover{box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);}
  .newslist li .cont{width: 876px;float: right;}
  .newslist li a .cont h1{display: block;width: 100%;height: 30px;line-height: 30px;margin-top: 20px;font-size: 20px;color: #333;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;}
  .newslist li a .cont .sp2{display: block;width: 100%;height: 52px;margin-top: 9px;margin-bottom: 9px;line-height: 26px;font-size: 16px;color: #333;display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
  .newslist li a .cont .sp3{display: block;width: 100%;color: #999;font-size: 14px;}
  .newslist-pageindex{width: 100%;height: auto;overflow: hidden;text-align: center;margin-bottom: 5px;margin-top: 15px;margin-bottom: 20px;}
  .newslist-pageindex a{display: inline-block;width: auto;height: 32px;background-color: #f2f2f2;color: #333333;font-size: 14px;line-height: 32px;min-width: 32px;box-sizing: border-box;padding: 0 5px; margin-left: 5px;margin-right: 5px;}
  .newslist-pageindex .active{background-color: #2a3c66;color:#fff}
  .newslist-pageindex a:hover{background-color: #2a3c66;color:#fff}
</style>



// WEBPACK FOOTER //
// src/page/newslist.vue